import Client from "@/domain/Client"

export const MIB = new Client(0, "МАЖБУРИЙ ИЖРО БЮРОСИ (MIB)")
export const GAI = new Client(1, "ГУББД (ГАИ)")
export const TTE = new Client(2, "Ташкент тепло-энергия (ТТЕ)")
export const JVM = new Client(3, "Министерство Юстиции (JVM)")
export const DXA = new Client(4, "ДАВЛАТ ХИЗМАТЛАР АГЕНТЛИГИ (DXA)")
export const FKT = new Client(5, "Фактура.уз (FKT)")
export const EHM = new Client(6, "Единая система гибридной почты (EHM)")
export const OSM = new Client(7, "Верховный суд РУз (OSM)")
export const PSB = new Client(8, "ПромСтройБанк (PSB)")
export const ORP = new Client(9, "Прокуратура РУз (ORP)")
export const EMI = new Client(10, "Э-маъмурий иш (EMI)")
export const XB = new Client(11, "Народный банк (XB)")
export const IYB = new Client(12, "Банк Ипак Йули (IYB)")
export const TBC = new Client(13, "ТБС Банк (TBC)")
export const AAB = new Client(14, "Азия Аллианс Банк (AAB)")
export const ASK = new Client(15, "Асака Банк (ASK)")
export const TNG = new Client(16, "Тенге Банк (TNG)")
export const ZDM = new Client(17, "Зудмолл (ZDM)")
export const VND = new Client(18, "Венду (VND)")
export const EKG = new Client(19, "Э-Кенгаш (EKG)")
export const IPK = new Client(22, "Ипотека Банк (IPK)")
export const MKB = new Client(23, "Микрокредит Банк (MKB)")
export const NBU = new Client(24, "НБУ Банк (NBU)")
export const GAI2 = new Client(25, "ГУББД (ГАИ2)")
export const GNK = new Client(27, "ГНК (GNK)")
export const DVR = new Client(28, "Давр Банк (DVR)")
export const MEXM = new Client(30, "Миллий электрон хизматлар маркази (MEXM)")
export const ALQ = new Client(31, "Aloqa Bank (ALQ)")
export const ADL = new Client(32, "Adliya vazirligi (ADL)")
export const BRB = new Client(34, "Qishloq Qurilish Bank (BRB)")
export const KAD = new Client(36, "Kadastr (KAD)")
export const ADV = new Client(38, "Advokatura (ADV)")
export const PJ = new Client(40, "Pensiya Jamgarmasi {PJ}")
export const MG = new Client(41, "Milliy gvardiya (MG)")
export const SL = new Client(43, "Solutions Lab (SL)")
export const AGR = new Client(44, "Agrobank (AGR)")
